module.exports = __webpack_public_path__ + "assets/hero-background.1496cd83.svg";